// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { SignInDialogGetString, SignInDialogGetStringAsync } from './types.generated'

const signInDialogLocales = ['en-US'] as const
const signInDialogBundle = i18nBundle('signInDialog/signInDialog', signInDialogLocales)

export const getString: SignInDialogGetString = signInDialogBundle.getString
export const getStringAsync: SignInDialogGetStringAsync = signInDialogBundle.getStringAsync
